/**
 * This class is used to define specific data type 
*/

export enum ROLES {
  ADMIN = 1,
  BUSSINESS = 2,
  USER = 3,
  SUPER_USER = 4,
}

export enum COUNTRIES {
  COLOMBIA = 1,
}

export enum DOCUMENT_TYPES {
  CC = 1,
  NIT = 2,
  TI = 3,
  CE = 4,
}

export const DocumentTypesMap = new Map()
DocumentTypesMap.set(DOCUMENT_TYPES.CC, {
  id: 1,
  name: 'Cédula de ciudadanía',
  acronym: 'CC',
  country_id: COUNTRIES.COLOMBIA,
})
DocumentTypesMap.set(DOCUMENT_TYPES.NIT, {
  id: 2,
  name: 'NIT',
  acronym: 'CC',
  country_id: COUNTRIES.COLOMBIA,
})
DocumentTypesMap.set(DOCUMENT_TYPES.TI, {
  id: 3,
  name: 'Tarjeta de identidad',
  acronym: 'TI',
  country_id: COUNTRIES.COLOMBIA,
})
DocumentTypesMap.set(DOCUMENT_TYPES.CE, {
  id: 4,
  name: 'Cédula de extranjería',
  acronym: 'CE',
  country_id: COUNTRIES.COLOMBIA,
})

export enum GENDER {
  MAN = 1,
  WOMAN = 2,
}

export const GenderMap = new Map()
GenderMap.set(DOCUMENT_TYPES.CC, {
  id: 1,
  name: 'Hombre',
})
GenderMap.set(DOCUMENT_TYPES.NIT, {
  id: 2,
  name: 'Mujer',
})

export enum CITY {
  BOGOTÁ = 1,
}

export const CityMap = new Map()
CityMap.set(CITY.BOGOTÁ, {
  id: 1,
  name: 'Bogotá',
  country_id: COUNTRIES.COLOMBIA
})